function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import clone from 'ramda/src/clone';
import pathOr from 'ramda/src/pathOr';
import CustomerCareKeys from '../../../../../locales/keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { fetchAdjustmentReasons, fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeLoadedSelector, MetadataOptionsForCodeValuesSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CreditReasonsLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors.deprecated';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { DEVICE_FINANCE_STATUS, NON_BULK_SERVICE_STATUSES } from 'invision-core/src/constants/status.constants';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { DeviceFinancingNameSelector, IsFetchingDeviceReturnDetailsSelector, SubscriberDeviceFinancingCurrencySelector, SubscriberDeviceFinancingDetailsDropdownSelector, SubscriberDeviceFinancingDetailsSelector, SubscriberDeviceFinancingWidgetActiveDeviceDetailsSelector, SubscriberDeviceFinancingWidgetActiveDiscountDetailsSelector, SubscriberDeviceReturnDetailsSelector } from '../../../../../reducers/selectors/customer.devices.selectors';
import { CanUserPerformFinanceAdjustmentSelector, CurrentCustomerIdSelector } from '../../../../../reducers/selectors/customer.selectors';
import { IsCoolingPeriodEnabledSelector } from '../../../../../reducers/selectors/customer.offerings.selectors';
import { createDeviceAdjustment, retrieveDeviceRefundAmount, setDeviceFinancingWidgetSelectedDevice } from '../../../../../reducers/actions/customer.devices.actions';
import { deviceFinancingFriendlyName, deviceFinancingImage, isDeviceFinanceCoolingOffStatus } from './device.financing.helper';
import { DOWN_PAYMENT_TYPE } from '../../../../../customercare.constants';
import { DEPOSIT_ADJUSTMENT } from '../../../../adjustment/adjustment.modal.constants';
import { MAKE_PAYMENT_ROUTE } from '../../../makePayment/make.payment.constants';
import { INVENTORY_STATE_NAME } from '../../../inventory/inventory.config';
import { CanReturnDeviceSelector } from '../../../../../reducers/selectors/apply.credit.modal.selectors';
import { ONE_TIME_MAKE_PAYMENT } from '../../../../../security.attributes';
var DeviceFinancingController = /*#__PURE__*/function () {
  function DeviceFinancingController($ngRedux, $state, $timeout, uiNotificationService) {
    _classCallCheck(this, DeviceFinancingController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      $timeout: $timeout,
      availableDevicesOptions: [],
      CustomerCareKeys: CustomerCareKeys,
      DEVICE_FINANCE_STATUS: DEVICE_FINANCE_STATUS,
      deviceFinancingFriendlyName: deviceFinancingFriendlyName,
      deviceFinancingImage: deviceFinancingImage,
      DOWN_PAYMENT_TYPE: DOWN_PAYMENT_TYPE,
      isDeviceFinanceCoolingOffStatus: isDeviceFinanceCoolingOffStatus,
      isExpanded: true,
      NON_BULK_SERVICE_STATUSES: NON_BULK_SERVICE_STATUSES,
      onCloseReturnDeviceModal: this.onCloseReturnDeviceModal.bind(this),
      onMoreActionsItemSelection: this.onMoreActionsItemSelection.bind(this),
      onSubmitReturnDeviceModal: this.onSubmitReturnDeviceModal.bind(this),
      thumbnailHeight: 95,
      thumbnailWidth: 65,
      toolTipTemplate: require('./device.finance.tooltip.template.info.html'),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(DeviceFinancingController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        createDeviceAdjustment: createDeviceAdjustment,
        fetchAdjustmentReasons: fetchAdjustmentReasons,
        fetchCodeType: fetchCodeTypes,
        retrieveDeviceRefundAmount: retrieveDeviceRefundAmount,
        setDeviceFinancingWidgetSelectedDevice: setDeviceFinancingWidgetSelectedDevice,
        stateGo: stateGo
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        var moreMenuItems = _this.getMoreMenuItems();
        return {
          adjustmentReasonsLoaded: MetadataCodeLoadedSelector(CODES.BalanceAdjustmentReason, store),
          adjustmentReasonOptions: MetadataOptionsForCodeValuesSelector(CODES.BalanceAdjustmentReason, store),
          availableDevices: SubscriberDeviceFinancingDetailsDropdownSelector(store),
          canReturnDevice: CanReturnDeviceSelector(store),
          canUserPerformFinanceAdjustment: CanUserPerformFinanceAdjustmentSelector(store),
          coolingPeriodLoaded: MetadataCodeLoadedSelector(CODES.CoolingPeriod, store),
          creditReasonsLoaded: CreditReasonsLoadedSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          deviceFinancingCurrencyCode: SubscriberDeviceFinancingCurrencySelector(store),
          deviceFinancingDetails: SubscriberDeviceFinancingDetailsSelector(store),
          deviceFinancingName: DeviceFinancingNameSelector(store),
          deviceReturnDetails: SubscriberDeviceReturnDetailsSelector(store),
          isCoolingPeriodEnabledForBU: IsCoolingPeriodEnabledSelector(store),
          isDbss: IsDbss(store),
          isFetchingDeviceReturnDetails: IsFetchingDeviceReturnDetailsSelector(store),
          moreMenuItems: moreMenuItems,
          reasonOptions: MetadataOptionsForCodeValuesSelector(CODES.CreditReasons, store),
          selectedDevice: SubscriberDeviceFinancingWidgetActiveDeviceDetailsSelector(store),
          selectedDeviceFinanceDiscounts: SubscriberDeviceFinancingWidgetActiveDiscountDetailsSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.updateOptions();
      this.adjustmentModalConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.adjustmentModalApi = api;
        }
      };
      this.returnDeviceModalConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.returnDeviceModalConfigApi = api;
        }
      };
      this.discountToolTip = require('../../../../shared/tooltipTemplates/discount.tooltip.html');
      this.fetchCodeTypes().then(function () {
        if (isDeviceFinanceCoolingOffStatus(_this.state.selectedDevice) && _this.state.isCoolingPeriodEnabledForBU) {
          _this.isCoolingOffEnabled = true;
          _this.tooltipContext = {
            title: i18n.translate(_this.CustomerCareKeys.CUSTOMER_DASHBOARD.DEVICE_FINANCING_COOLING_PERIOD)
          };
        } else {
          _this.isCoolingOffEnabled = false;
        }
      });
    }
  }, {
    key: "fetchCodeTypes",
    value: function fetchCodeTypes() {
      var promises = [];
      if (!this.state.creditReasonsLoaded) {
        promises.push(this.actions.fetchCodeType(CODES.CreditReasons));
      }
      if (!this.state.coolingPeriodLoaded) {
        promises.push(this.actions.fetchCodeType(CODES.CoolingPeriod));
      }
      if (!this.state.adjustmentReasonsLoaded) {
        this.actions.fetchAdjustmentReasons();
      }
      return Promise.all(promises);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "handleExpansion",
    value: function handleExpansion() {
      this.isExpanded = !this.isExpanded;
    }
  }, {
    key: "discountTooltipText",
    value: function discountTooltipText() {
      if (this.state.selectedDeviceFinanceDiscounts.length > 0) {
        return "".concat(this.state.selectedDeviceFinanceDiscounts.length, " ").concat(i18n.translate(this.state.selectedDeviceFinanceDiscounts.length === 1 ? CustomerCareKeys.DISCOUNT : CustomerCareKeys.DISCOUNTS_LABEL));
      }
    }
  }, {
    key: "updateSelectedDevice",
    value: function updateSelectedDevice(option) {
      this.actions.setDeviceFinancingWidgetSelectedDevice(option.index);
      this.updateOptions();
    }
  }, {
    key: "onAdjustmentClose",
    value: function onAdjustmentClose() {
      this.adjustmentModalApi.close();
      this.showAdjustmentModal = false;
    }
  }, {
    key: "onSubmitAdjustmentModal",
    value: function onSubmitAdjustmentModal() {
      this.retrieveConvergentBillerAndDeviceFinancingDetails && this.retrieveConvergentBillerAndDeviceFinancingDetails();
      this.refreshServices && this.refreshServices();
      this.onAdjustmentClose();
    }
  }, {
    key: "onMoreActionsItemSelection",
    value: function onMoreActionsItemSelection(option) {
      switch (option.item.id) {
        case this.CustomerCareKeys.VIEW_DETAILS:
          this.actions.stateGo(INVENTORY_STATE_NAME, {
            customerId: this.state.currentCustomerId,
            inventoryId: pathOr(null, ['state', 'selectedDevice', 'SubscriberInventory', 'Id'], this)
          });
          break;
        case this.CustomerCareKeys.MAKE_A_PAYMENT:
          this.actions.stateGo(MAKE_PAYMENT_ROUTE, {
            account: this.state.selectedDevice.DeviceFinanceAccountNumber
          });
          break;
        case this.CustomerCareKeys.ADJUSTMENTS.APPLY_ADJUSTMENT:
          option.item.action();
          break;
        case this.CustomerCareKeys.INVENTORY.RETURN_DEVICE:
          option.item.action();
          break;
        default:
          break;
      }
    }
  }, {
    key: "getMoreMenuItems",
    value: function getMoreMenuItems() {
      var _this2 = this;
      var moreMenuItems = [];
      if (this.state && this.state.selectedDevice && this.state.selectedDevice.DeviceFinanceAccountNumber && this.state.canUserPerformFinanceAdjustment) {
        moreMenuItems = [{
          id: this.CustomerCareKeys.VIEW_DETAILS,
          title: i18n.translate(this.CustomerCareKeys.VIEW_DETAILS)
        }, {
          id: this.CustomerCareKeys.ADJUSTMENTS.APPLY_ADJUSTMENT,
          title: i18n.translate(this.CustomerCareKeys.ADJUSTMENTS.APPLY_ADJUSTMENT),
          action: function action() {
            _this2.adjustmentType = DEPOSIT_ADJUSTMENT;
            _this2.showAdjustmentModal = true;
            _this2.$timeout(function () {
              _this2.adjustmentModalApi.open();
            });
          }
        }];
      } else {
        moreMenuItems = [{
          id: this.CustomerCareKeys.VIEW_DETAILS,
          title: i18n.translate(this.CustomerCareKeys.VIEW_DETAILS)
        }];
      }
      if (this.state && hasAccess(this.state.userSecurityAttributes, ONE_TIME_MAKE_PAYMENT)) {
        moreMenuItems.push({
          id: this.CustomerCareKeys.MAKE_A_PAYMENT,
          title: i18n.translate(this.CustomerCareKeys.MAKE_A_PAYMENT)
        });
      }
      if (this.state && this.state.canReturnDevice) {
        moreMenuItems.push({
          id: this.CustomerCareKeys.INVENTORY.RETURN_DEVICE,
          title: i18n.translate(this.CustomerCareKeys.INVENTORY.RETURN_DEVICE),
          action: function action() {
            _this2.actions.retrieveDeviceRefundAmount(_this2.state.selectedDevice.SubscriberInventory && _this2.state.selectedDevice.SubscriberInventory.SubscriberProductId, _this2.state.currentCustomerId).then(function () {
              _this2.showReturnDeviceModal = true;
              _this2.$timeout(function () {
                _this2.returnDeviceModalConfigApi.open();
              });
            }).catch(function (error) {
              _this2.uiNotificationService.transientError(error.translatedMessage);
            });
          }
        });
      }
      return moreMenuItems;
    }
  }, {
    key: "onCloseReturnDeviceModal",
    value: function onCloseReturnDeviceModal() {
      this.showReturnDeviceModal = false;
      this.returnDeviceModalConfigApi.close();
    }
  }, {
    key: "onSubmitReturnDeviceModal",
    value: function onSubmitReturnDeviceModal(deviceDetails) {
      var _this3 = this;
      this.actions.createDeviceAdjustment(deviceDetails, this.state.currentCustomerId).then(function () {
        _this3.retrieveConvergentBillerAndDeviceFinancingDetails && _this3.retrieveConvergentBillerAndDeviceFinancingDetails();
        _this3.refreshServices && _this3.refreshServices();
        _this3.uiNotificationService.success(i18n.translate(_this3.CustomerCareKeys.CUSTOMER_DASHBOARD.DEVICE_RETURN_SUCCESS));
      }).catch(function (error) {
        _this3.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this3.onCloseReturnDeviceModal();
      });
    }
  }, {
    key: "getDeviceFinancingMarketingNameForHeading",
    value: function getDeviceFinancingMarketingNameForHeading() {
      return i18n.translate(this.CustomerCareKeys.CUSTOMER_DASHBOARD.DEVICE_FINANCING_FOR, {
        deviceFinancingName: this.state.deviceFinancingName
      });
    }
  }, {
    key: "updateOptions",
    value: function updateOptions() {
      this.availableDevicesOptions = clone(this.state.availableDevices);
    }
  }]);
}();
export default {
  template: require('./device.financing.html'),
  controller: DeviceFinancingController,
  bindings: {
    refreshServices: '&?',
    retrieveConvergentBillerAndDeviceFinancingDetails: '&?'
  }
};